import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { UtilityValueRaw } from 'brain-data/model/utility-value-raw.model';

@Injectable({ providedIn: 'root' })
export class ContractRawValuesService {
  constructor(private http: HttpClient) {}

  getByContractNumber(contractNumber: string): Observable<UtilityValueRaw[]> {
    const trimmed = contractNumber.trim();
    return this.http.get<UtilityValueRaw[]>(`${environment.apiBaseUrl}/utility-values/by-contract/${encodeURIComponent(trimmed)}/raw`);
  }
}
